module.exports = __webpack_public_path__ + "audio-guide/img/audiohead.ab5ffaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/audiohead.png
// module id = c4EE
// module chunks = 1